module.exports = __webpack_public_path__ + "img/new_assur.8f8f209b.png";